import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../helpers';

// create slice

const name = 'permanent';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const permanentActions = { ...slice.actions, ...extraActions };
export const permanentReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        permanent: 0,
        error: null
    }
}

function createExtraActions() {

    const baseUrl = `${import.meta.env.VITE_API_URL}/api/permanent/`;

    return {
        getOne: getOne()
    };    

    function getOne() {
        return createAsyncThunk(
            `${name}/getOne`,
            async (user) => fetchWrapper.get(baseUrl+user)
        );
    }
}

function createExtraReducers() {
    return (builder) => {
        builder
            .addCase(extraActions.getOne.pending, (state) => {
                state.permanent = 0;
            })
            .addCase(extraActions.getOne.fulfilled, (state, action) => {
                state.permanent = action.payload.etat;
            })
            .addCase(extraActions.getOne.rejected, (state, action) => {
                state.error = action.error;
            });
    };
}
